module.exports = __webpack_public_path__ + "img/savings-jar.a36a8d08.jpg";